import { ILoginData, IForgotPassword ,IVerify} from '../../types';
export const APIJSON = {
  login: ({ email, password }: ILoginData) => {
    return {
      email: email,
      password: password,
    };
  },
  forgotPassword: ({ email }: IForgotPassword) => {
    return {
      email: email,
    };
  },
  verify: ({ code }: IVerify) => {
    return { code: code };
  },
};
